@if (tenantStore.id()) {
  <shared-form-header [formTitle]="tenantStore.name()">
    <div form-content>
      @let errors = loginErrors();
      <div class="error-wrapper">
        @for (error of errors; track error.id) {
          <orbit-message
            [message]="error.message ?? error.code | translate"
            [severity]="'error'"
            [titleTestId]="'error-login-title-' + error.id"
            [messageTestId]="'error-login-message-' + error.id" />
        }
      </div>
      <shared-login-form (loginAttempt)="loginAttempt($event)" (resetLogin)="resetLoginErrors()" />
    </div>
  </shared-form-header>
} @else {
  @let errors = tenantErrors();
  @if (errors && errors.length > 0 && errors[0]) {
    @let error = errors[0];
    <shared-global-error
      [message]="error.message ?? error.code | translate"
      [unknownError]="false"
      [hasReload]="false" />
  } @else {
    <orbit-fa-icon class="loading-icon" [iconName]="spinnerIcon" animation="spin" iconSize="2x" />
  }
}
